module.exports = __webpack_public_path__ + "static/media/point_apport_icon.b1154704.svg";